module.exports = __webpack_public_path__ + "img/draw.dbac38c2.webp";